import { extend } from 'sk-ui/lib/utils/util.js'

import copyMultiOsTypeForm from './../osTypeMng/metaData/copyMultiOsTypeForm'
import relateFeature from './metaData/relateFeature'
import relateSegmentScene from './metaData/relateSegmentScene'

import scene from './metaData/scene'
import sceneForm from './metaData/sceneForm'

import { getSceneDetail, queryScenes } from '@/api/scene'

import batchProductUpgrade from '@/components/BatchProductUpgrade'
import batchUpdateSceneDir from '@/components/BatchUpdateSceneDir'
import productUpgrade from '@/components/ProductUpgrade'

export default {
  SceneCreate({ commit }, params) {
    const props = {
      extraParams: {
        industryId: params.viewController?.viewMetaData?.params?.industryId
      }
    }
    this.dispatch('OpenFullDialog', {
      metaData: sceneForm,
      props
    })
  },
  CheckOsTypeForProduct({ commit }, props) {
    if (props?.response?.data?.status == 'SUCCESS') {
      let productList = props?.response?.data?.content
      if (productList && productList.length > 0) {
        let product = productList.map(item => item.productVersion).join(', ')
        let copyList = []
        productList.forEach((item, index) => {
          let copy = {
            sourceProductId: null,
            sourceProduct: null,
            targetProductId: item.id,
            targetProduct: item.productVersion
          }
          copyList.push(copy)
        })
        this.$root
          .$confirm('OpenConfirm', {
            title: '提示',
            message:
              '场景保存成功，但产品版本【' +
              product +
              '】对应的操作系统限制配置不存在，需要到【操作系统配置】模块进行配置，否则影响项目正常创建，确定进行配置吗？',
            showCancelButton: true,
            type: 'warning'
          })
          .then(btnAction => {
            const props = { copyMultiOsTypeList: copyList }
            this.dispatch('OpenFullDialog', {
              metaData: copyMultiOsTypeForm,
              props
            })
          })
          .catch(btnAction => {})
      }
    }
  },
  RelationScene({ commit }, props) {
    props.params = {
      industryId: props.rootView.views.extraParams.industryId
    }
    this.dispatch('OpenRelationDialog', { metaData: scene, props, clone: false })
  },
  SceneEdit({ commit }, params) {
    const props = {
      title: '编辑场景',
      params: {
        id: params.rowIds[0]
      },
      'view.content[$id=sceneCode].$el': { disabled: true },
      extraParams: {
        industryId: params.viewController?.viewMetaData?.params?.industryId
      }
    }
    const editForm = extend(true, {}, sceneForm)
    this.dispatch('OpenFullDialog', { metaData: editForm, props, clone: false })
  },
  SceneFeatureRelate({ commit }, params) {
    const props = {
      params: {
        id: params.rowIds[0]
      },
      extraParams: {
        sceneId: params.rowIds[0],
        recommendProduct: params.row.recommendProduct
      }
    }
    this.dispatch('OpenFullDialog', {
      metaData: relateFeature,
      props
    })
  },
  segmentSceneRelate({ commit }, params) {
    const props = {
      params: {
        id: params.rowIds[0]
      },
      extraParams: {
        sceneId: params.rowIds[0]
      }
    }
    this.dispatch('OpenFullDialog', {
      metaData: relateSegmentScene,
      props
    })
  },
  RelationFeature({ commit }, props) {
    if (props?.rootView?.views?.extraParams?.recommendProduct) {
      const recommendProductArr = props?.rootView?.views?.extraParams?.recommendProduct.split(',')
      if (!props.params) {
        props.params = {}
      }
      props.params = {
        productId: recommendProductArr
      }
    }
    import('../featureMng/metaData/feature').then(metaData => {
      const metaDataCopy = extend(true, {}, metaData)
      metaDataCopy.default.view.columns.unshift({
        props: {
          type: 'selection',
          width: 55
        }
      })
      metaDataCopy.default.view.menus = [
        {
          icon: 'el-icon-edit',
          label: '关联用例',
          command: 'featureRelateTestCase',
          name: 'featureRelateTestCase'
        }
      ]
      this.dispatch('OpenRelationDialog', { metaData: metaDataCopy, props })
    })
  },
  RelationSegmentScene({ commit }, props) {
    import('../segmentSceneMng/metaData/segmentScene').then(metaData => {
      const metaDataCopy = extend(true, {}, metaData)
      metaDataCopy.default.view.columns.unshift({
        props: {
          type: 'selection',
          width: 55
        }
      })
      this.dispatch('OpenRelationDialog', { metaData: metaDataCopy, props })
    })
  },
  BatchUpdateProduct({ commit }, params) {
    if (params.rows.length === 0) {
      this.dispatch('OpenNotification', { message: '请选择至少一个场景', type: 'error' })
      return
    }
    params.viewController.loading = true
    queryScenes({ idArr: params.rowIds }).then(response => {
      const industryId = params.viewController.views.params.industryId
      var dialog = params.viewController.$dialog({
        template: h => {
          const scenes = response?.data?.content
          return (
            <sky-batch-product-upgrade
              scenes={scenes}
              industryId={industryId}
              onCb={function() {
                dialog.remove()
                params.viewController.handleRefresh()
              }}
            />
          )
        },
        components: {
          batchProductUpgrade
        },
        props: {
          title: '批量升级产品版本',
          width: '60%',
          showDefaultFooter: false,
          closeOnPressEscape: false
        }
      })
    })
  },
  BatchUpdateSceneDir({ commit }, params) {
    if (params.rows.length === 0) {
      this.dispatch('OpenNotification', { message: '请选择至少一个场景', type: 'error' })
      return
    }
    const srcIndustryId = params.rows[0].industryId
    var dialog = params.viewController.$dialog({
      template: h => {
        const rowIds = params.rowIds
        const industryId = srcIndustryId
        return (
          <sky-batch-update-scene-dir
            rowIds={rowIds}
            industryId={industryId}
            onCb={function() {
              dialog.remove()
              params.viewController.handleRefresh()
            }}
          />
        )
      },
      components: {
        batchUpdateSceneDir
      },
      props: {
        title: '批量设置场景目录',
        width: '22%',
        showDefaultFooter: false, //隐藏确定和取消按钮
        closeOnPressEscape: false
      }
    })
  },
  ProductUpgrade({ commit }, params) {
    getSceneDetail({ id: params.rowId }).then(response => {
      var title = '升级场景产品版本（选择需要进行升级的产品，可多选）'
      var dialog = params.viewController.$dialog({
        template: h => {
          const scene = response?.data?.content
          return (
            <sky-product-upgrade
              scene={scene}
              onCb={function() {
                dialog.remove()
                params.viewController.fetch()
              }}
            />
          )
        },
        components: {
          productUpgrade
        },
        props: {
          title: title,
          width: '55%',
          showDefaultFooter: false,
          closeOnPressEscape: false
        }
      })
    })
  }
}
